export class StrategyNodeRequest {
    constructor(
        public strategyId?:any,
        public previousNodeId?:any,
        public previousNodeRelation?:any,
        public definition?:any,
        public nodeType?:any,
        public merchantId?:any
    ) { }
}